import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TableBody, TableCell, TableRow } from '@digdir/designsystemet-react';

import useFormatDate from '../../../../../hooks/useFormatDate';
import { Konstruksjonstetthet } from '../../../../../types/registration/userInput';
import {
  LeftBorderCell,
  StyledTable
} from '../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface KonstruksjonstetthetProps {
  tetthet: Konstruksjonstetthet;
}
export const KonstruksjonstetthetView: FC<KonstruksjonstetthetProps> = ({ tetthet }) => {
  const { t } = useTranslation();
  const { formatDate } = useFormatDate();

  return (
    tetthet && (
      <StyledTable>
        <TableBody>
          {tetthet.dato && (
            <TableRow>
              <TableCell>{t('register.lekkasjetall.label')}</TableCell>
              <LeftBorderCell>{tetthet.lekkasjetall}</LeftBorderCell>
            </TableRow>
          )}
          {tetthet.lekkasjetall && (
            <TableRow>
              <TableCell>{t('register.lekkasjetall.dato.label')}</TableCell>
              <LeftBorderCell>{formatDate(tetthet.dato)}</LeftBorderCell>
            </TableRow>
          )}
        </TableBody>
      </StyledTable>
    )
  );
};
